export default __webpack_public_path__ + "static/media/light.3f9703a6.png";